export default __webpack_public_path__ + "static/media/schedule-grey.ef84b3cc.svg";